import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  FormGroup,
  InputGroup,
  HTMLSelect,
  NumericInput,
  Icon,
  Popover,
  Position,
  PopoverInteractionKind,
  Card
} from "@blueprintjs/core";
import ToastStore from "../../stores/ToastStore";
import { FilledButton } from "../buttons-20250224T111359Z-001/buttons";
import { TextButton } from "../buttons-20250224T111359Z-001/buttons";
import Flexbox from "flexbox-react";
// import "./QuestionFormPanel.css";

const QuestionTypes = {
  Checkbox: "Checkbox",
  Radio: "Radio",
  TextBox: "TextBox",
  DropDown: "DropDown",
  ShortAnswer: "ShortAnswer",
  Files: "Files"
};

const DISPLAY_VALUES = {
  [QuestionTypes.TextBox]: "Detailed Answer",
  [QuestionTypes.ShortAnswer]: "Short Answer",
  [QuestionTypes.Files]: "Attachment",
  [QuestionTypes.DropDown]: "Select from Dropdown",
  [QuestionTypes.Radio]: "Multiple Choice (Select One)",
  [QuestionTypes.Checkbox]: "Multiple Choice (Select Multiple)",
};

const QuestionFormPanel = ({
  initialData,
  editingGroup,
  categoryOptions = [],
  jobProfileList = [],
  selectedJobProfileForCategory,
  setSelectedJobProfileForCategory,
  isWeightAllow,
  onSubmit,
  isSaving = false,
  onAddCategory,
  onImportCategory,
  isCategoryUploading,
  isCategoryDownloading
}) => {

  // const fileInputRef = useRef(null);

  const [selectedType, setSelectedType] = useState("TextBox");
  const [questionText, setQuestionText] = useState("");
  const [answerOptions, setAnswerOptions] = useState({});
  const [optionIndex, setOptionIndex] = useState(1);
  const [weight, setWeight] = useState("");
  const [selectedJobProfile, setSelectedJobProfile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");



  useEffect(() => {
    if (initialData) {
      setSelectedType(initialData.question_type);
      setQuestionText(initialData.question);
      setAnswerOptions(initialData.value || {});
      setOptionIndex(Object.keys(initialData.value || {}).length + 1);
      setWeight(initialData.weightage || "");
      if (editingGroup?.category_id) {
        const matchedCategory = categoryOptions.find(
          cat => cat.id === editingGroup?.category_id
        );
        setSelectedCategory(matchedCategory || null);
      } else {
        setSelectedCategory(null);
      }
      if (initialData?.job_profile_id) {
        const matchedJobProfile = jobProfileList.find(
          job => String(job.id) === String(initialData.job_profile_id)
        );

        setSelectedJobProfileForCategory(
          matchedJobProfile || null
        );
      }

    } else {
      // RESET FORM
      setSelectedType("TextBox");
      setQuestionText("");
      setAnswerOptions({});
      setOptionIndex(1);
      setWeight("");
      setSelectedCategory(null);
      // setSelectedJobProfileForCategory(null);
    }

  }, [initialData]);

  useEffect(() => {
    if (!selectedJobProfileForCategory) {
      setSelectedCategory(null);
      return;
    }
  
    // Keep the category if it still exists in the new list
    const exists = categoryOptions.find(
      cat => String(cat.id) === String(selectedCategory?.id)
    );
  
    if (!exists) {
      setSelectedCategory(null);
    }
  }, [selectedJobProfileForCategory, categoryOptions]);

  // useEffect(() => {
  //   setSelectedCategory(null);
  // }, [selectedJobProfileForCategory?.id]);

  //  Options handlers
  const handleAddOption = () => {
    const key = `option${optionIndex}`;
    setAnswerOptions(prev => ({ ...prev, [key]: "" }));
    setOptionIndex(prev => prev + 1);
  };

  const handleOptionChange = (key, value) => {
    setAnswerOptions(prev => ({ ...prev, [key]: value }));
  };

  const handleDeleteOption = (key) => {
    const updated = { ...answerOptions };
    delete updated[key];
    setAnswerOptions(updated);
  };

  const validateForm = () => {

    if (!questionText.trim()) {
      ToastStore?.showToast("Question text is required!", "danger");
      return false;
    }
    const requiresOptions = ["Radio", "DropDown", "Checkbox"];
    if (requiresOptions.includes(selectedType) && Object.keys(answerOptions).length === 0) {
      ToastStore?.showToast("Please add at least one option!", "danger");
      return false;
    }
    // empty option
    if (requiresOptions.includes(selectedType)) {
      const hasEmpty = Object.values(answerOptions).some(option => !option?.trim());
      if (hasEmpty) {
        ToastStore?.showToast("Please fill all option values!", "danger");
        return false;
      }
    }
    // weight validation
    if (isWeightAllow && (weight === "" || weight === null)) {
      ToastStore?.showToast("Weight is required!", "danger");
      return false;
    }
    return true;
  };

  //  Submit
  const handleSubmit = async () => {
    if (isSaving || !validateForm()) {
      return;
    }
    await onSubmit({
      question: questionText,
      question_type: selectedType,
      value: answerOptions,
      weightage: weight,
      category_id: selectedCategory?.id,
      job_profile_id: selectedJobProfileForCategory?.id
    });

  };

  const clearForm = () => {
    setSelectedType("TextBox");
    setQuestionText("");
    setAnswerOptions({});
    setOptionIndex(1);
    setWeight("");
    setSelectedCategory(null);
    setSelectedJobProfileForCategory(null);
  };

  return (
    <Card className="question-form-panel">

      {/* CATEGORY + IMPORT */}
      <Flexbox flexDirection="row" justifyContent="space-between" alignItems="center" className="push-b-20" style={{ marginBottom: "15px" }}>
        <div className="form-actions" >
          {/* {isAddingCategory ? (
            <input
              autoFocus
              className="category-input"
              placeholder="Enter category"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              onKeyDown={async (e) => {
                if (e.key === "Enter" && newCategory.trim()) {
                  await onAddCategory(newCategory.trim());
                  setNewCategory("");
                  setIsAddingCategory(false);
                }
              }}
              onBlur={() => setIsAddingCategory(false)}
            />
          ) : (
            <TextButton
              text="+ Add Category"
              onClick={() => setIsAddingCategory(true)}
            />
          )} */}

          {/* IMPORT */}
          {/* <Popover
            position={Position.BOTTOM_RIGHT}
            interactionKind={PopoverInteractionKind.CLICK}
            content={
              <div className="import-popover">

                <div
                  className="import-item"
                  onClick={!isCategoryDownloading ? onImportCategory?.download : undefined}
                >
                  <Icon icon="download" />
                  <div>Download Sample</div>
                </div>

                <div
                  className="import-item"
                  onClick={!isCategoryUploading ? () => fileInputRef.current.click() : undefined}
                >
                  <Icon icon="upload" />
                  <div>Upload File</div>
                </div>

              </div>
            }
          >
            <Button icon="import" />
          </Popover>

          <input
            ref={fileInputRef}
            type="file"
            style={{ display: "none" }}
            onChange={onImportCategory?.upload}
          /> */}

        </div>

        <Flexbox
          flexDirection="row"
          alignItems="center"
          style={{
            flex: 1,
            minWidth: 0,
            flexWrap: "wrap",
            columnGap: "14px",
            rowGap: "10px"
          }}
        >
          {jobProfileList.length > 0 && (
            <select
              className="form-select"
              value={selectedJobProfileForCategory?.id || ""}
              onChange={(e) => {
                const selected = jobProfileList.find(
                  job => String(job.id) === e.target.value
                );

                setSelectedJobProfileForCategory(
                  selected || null
                );
              }}
            >
              <option value="">
                All Job Profiles
              </option>

              {jobProfileList.map(job => (
                <option key={job.id} value={job.id}>
                  {job.name}
                </option>
              ))}
            </select>
          )}

          <select
            className="form-select"
            style={{
              flex: "1 1 220px",
              minWidth: "220px",
              maxWidth: "260px",
              height: "34px",
              padding: "0 10px",
              margin: 0
            }}
            value={selectedCategory?.id || ""}
            onChange={(e) => {
              const selected = categoryOptions.find(
                c => c.id === e.target.value
              );
              setSelectedCategory(selected || null);
            }}
            disabled={categoryOptions.length === 0}
          >
            {categoryOptions.length === 0 ? (
              <option value="">
                No Departments for this job profile
              </option>
            ) : (
              <>
                <option value="">
                  Select Department
                </option>

                {categoryOptions.map(cat => (
                  <option key={cat.id} value={cat.id}>
                    {cat.label}
                  </option>
                ))}
              </>
            )}
          </select>

        </Flexbox>
      </Flexbox>

      {/* TYPE */}
      <FormGroup label="Type">
        <HTMLSelect
          fill
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          options={Object.entries(DISPLAY_VALUES).map(([value, label]) => ({
            value,
            label
          }))}
        />
      </FormGroup>

      {/* QUESTION */}
      <FormGroup label="Question">
        <textarea
          className="bp3-input bp3-textarea bp3-fill"
          rows={5}
          dir="auto"
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
          placeholder="Enter your question"
        />
      </FormGroup>

      {/* OPTIONS */}
      {
        ![QuestionTypes.ShortAnswer, QuestionTypes.TextBox, QuestionTypes.Files].includes(selectedType) && (
          <FormGroup label="Options">

            {Object.entries(answerOptions).map(([key, val]) => (
              <div key={key} className="option-row">
                <InputGroup
                  width={300}
                  value={val}
                  onChange={(e) => handleOptionChange(key, e.target.value)}
                />
                <Button icon="trash" minimal onClick={() => handleDeleteOption(key)} />
              </div>
            ))}

            <Button minimal text="+ Add Option" onClick={handleAddOption} />
          </FormGroup>
        )
      }

      {/* WEIGHT */}
      {
        isWeightAllow && (
          <FormGroup label="Weightage">
            <NumericInput
              value={weight}
              onValueChange={setWeight}
              min={0}
              max={100}
              fill
            />
          </FormGroup>
        )
      }

      {/* SAVE */}
      <div className="form-submit" style={{ display: "flex", alignItems: "center" }}>
        <FilledButton intent="primary" text="Save Question" onClick={handleSubmit} disabled={isSaving} />
        <TextButton text="Clear" onClick={clearForm} disabled={isSaving} />
        {isSaving && <img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Saving..." role="status" />}
      </div>

    </Card >
  );
};

export default QuestionFormPanel;